import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { units } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';
import { localizedPath } from '../config/seo';
import SeoHead from '../components/SeoHead';
import './TresImmo.css';

const copy = {
  de: { back: 'Alle Einheiten', label: 'Einheit', request: 'Exposé für diese Einheit anfordern', available: 'Verfügbar', reserved: 'Reserviert', sold: 'Verkauft', floor: 'Etage', rooms: 'Zimmer', area: 'Wohnfläche', price: 'Preis' },
  it: { back: 'Tutte le unità', label: 'Unità', request: 'Richiedi il prospetto di questa unità', available: 'Disponibile', reserved: 'Riservato', sold: 'Venduto', floor: 'Piano', rooms: 'Locali', area: 'Superficie', price: 'Prezzo' },
  en: { back: 'All units', label: 'Unit', request: 'Request the exposé for this unit', available: 'Available', reserved: 'Reserved', sold: 'Sold', floor: 'Floor', rooms: 'Rooms', area: 'Living area', price: 'Price' },
};

export default function UnitPage() {
  const { id } = useParams();
  const { lang } = useLanguage();
  const unit = units.find((item) => item.id.toLowerCase() === String(id).toLowerCase());
  const c = copy[lang] || copy.de;
  if (!unit) return <><SeoHead page="unit" noindex /><main className="content-page"><h1>404</h1><p>Diese Einheit wurde nicht gefunden.</p><Link to={localizedPath(lang, '/')}>{c.back}</Link></main></>;
  const status = unit.status === 'available' ? c.available : unit.status === 'reserved' ? c.reserved : c.sold;
  const path = `/einheiten/${unit.id.toLowerCase()}`;
  return (
    <>
      <SeoHead page="home" path={path} unit={unit} title={`${unit.id} – ${unit.area} in Oberbozen | TRES IMMO`} description={`${unit.id}: ${unit.rooms}, ${unit.area}, ${unit.floor}. ${status} im Wohnprojekt Am Waldrand in Oberbozen.`} />
      <main className="content-page unit-detail-page">
        <Link className="content-back-link" to={localizedPath(lang, '/')}>← {c.back}</Link>
        <p className="section-label visible">{c.label} {unit.id}</p>
        <h1>{unit.id} <em>Am Waldrand</em></h1>
        <p className={`unit-detail-status ${unit.status}`}>{status}</p>
        <div className="unit-detail-grid">
          <div><span>{c.floor}</span><strong>{unit.floor}</strong></div>
          <div><span>{c.rooms}</span><strong>{unit.rooms}</strong></div>
          <div><span>{c.area}</span><strong>{unit.area}</strong></div>
          <div><span>{c.price}</span><strong>{unit.price}</strong></div>
        </div>
        <p className="content-lead">Wohnen am Waldrand in Oberbozen: alpine Architektur, Panoramablick und zeitgemäßer Komfort am Ritten.</p>
        {unit.status !== 'sold' && <Link className="hero-cta-btn primary unit-detail-cta" to={`${localizedPath(lang, '/')}#coming-soon`}>{c.request} →</Link>}
      </main>
    </>
  );
}
